export default function toggleLanguage(currentLanguage) {
  const $elementsToChange = Array.from(
    document.querySelectorAll('[data-language]')
  )

  // console.log(currentLanguage)
  // console.log($elementsToChange)
  const currentContent = {}
  for (const item of $elementsToChange) {
    currentContent[item.dataset.language] = item.innerHTML
  }

  // console.log(currentContent)

  switch (currentLanguage) {
    case 'ES':
      {
        const spanishTextContent = {
          'about-link': 'Sobre mi',
          'contact-link': 'Contacto',
          'inspiration-link': 'Mi Inspiración',
          'presentation-text': 'Tengo experiencia en desarrollo web usando React en el frontend y Golang con MySQL para el backend, adicionalmente tengo conocimientos en Docker, AWS y React Native.',
          'projects-link': 'Proyectos',
          title: 'Hola! Soy Julian Florez<br/>Desarrollador full stack con<br />React y Golang',
          'projects-title': 'Estos son mis mejores proyectos',
          // 'project1-title': 'App del clima',
          // 'project1-description': 'Pronostico del clima para el día actual y los próximos 7 días. Usé la API de open weather para obtener los datos dinámicamente. También, implementé un menú lateral para presentar el clima en todos los paises del mundo.',
          'project1-title': 'App de ofertas de trabajo',
          'project1-description': 'Aplicación fullstack para publicar ofertas de empleo hecha con Golang, MySQL, HTML, CSS, JS, Docker y AWS. Los usuarios pueden registrarse e iniciar sesión tanto como aspirante y como empresa, pueden ver, filtrar y aplicar a ofertas así como crear sus propias ofertas.',
          // 'project2-title': 'Generador de consejos',
          // 'project2-description':
          //   "Este  proyecto te permite generar un consejo aleatorio gracias a la API 'Advice slip JSON API'. También implementé un loader para el estado de carga del consejo.",
          // 'project3-title': 'Carrito de compras con Redux',
          'project2-title': 'App para radicar arriendo',
          'project2-description':
            "Aplicación freelance para una agencia local en donde los usuarios pueden solicitar un contrato de arriendo usando su información personal así como información de uno hasta cinco codeudores. Incluye formulario multi-pantalla, validaciones, estados de carga rutas para diferentes contratos, carga de documentos y más.",
          'project3-title': 'App del clima',
          'project3-description':
            'Pronostico del clima para el día actual y los próximos 7 días. Usé la API de open weather para obtener los datos dinámicamente. También, implementé un menú lateral para presentar el clima en todos los paises del mundo.',
          'project4-title': 'Generador de consejos',
          'project4-description':
            `Este  proyecto te permite generar un consejo aleatorio gracias a la API 'Advice slip JSON API'. También implementé un loader para el estado de carga del consejo.`,
          'project-github1': 'Repositorio',
          'project-site1': 'Demo',
          'project-github2': 'Repositorio',
          'project-site2': 'Demo',
          'project-github3': 'Repositorio',
          'project-site3': 'Demo',
          'about-title': 'Sobre Mi',
          'about-description-text1':
            'Soy profesional en ingeniería aeronáutica y me he dedicado al desarrollo web por un par de años, enfocado principalmente en el frontend, aunque también tengo experiencia en desarrollo backend y manejo de bases de datos, así como el uso de Docker y AWS para el despliegue de las aplicaciones.',
          'about-description-text2':
            'De manera más personal me gusta pasar tiempo con mi familia y amigos y entrenar regularmente. También hago dibujos a lápiz muy ocasionalmente ✍️ <span class="about__arrow-icon">🔽</span>',
          'tech-stack-title': 'Tecnologías',
          'tech-stack-current':
            'Estas son las tecnologías que uso regularmente:',
          'tech-stack-future': 'Y algunas que me gustaría aprender:',
          'inspiration-title': 'Mi Inspiración',
          'inspiration-description':
            'Algunas de las personas que me inspiran a ser mejor persona y desarrollador:',
          'inspiration-jon-list':
            '<li>Creador de contenido</li><li>Profesor de tecnologías web</li>',
          'inspiration-estefany-list':
            '<li>Crack de CSS</li><li>Desarrolladora frontend</li><li>Profesora en Platzi</li>',
          'inspiration-midu-list':
            '<li>Creador de contenido</li><li>Experto en React</li>',
          'inspiration-kevin-list':
            "<li>Creador de contenido</li><li>'Evangelista' de CSS</li>",
          // 'inspiration-angelika-list':
          //   '<li>Desarrolladora full-stack senior</li><li>Crack de Elixir</li><li>Encardada de la rama de Elixir en exercism.io</li>',
          'contact-title': 'Contacto',
          'contact-text':
            'Actualmente estoy buscando un cargo como desarrollador fullstack <br>(<span class="contact__react">React - Golang</span>), si crees que me adapto a las necesidades de tu equipo no dudes en contactarme.',
          'contact-cv-link': 'Descargar CV',
        }
        document
          .querySelectorAll('div[data-toggle-language]')
          .forEach(element => {
            element.textContent = 'EN'
          })

        for (const item of $elementsToChange) {
          const key = item.dataset.language
          // if()
          // item.textContent = spanishTextContent[key]
          item.innerHTML = spanishTextContent[key]
          // item.innerHTML = $elementsToChange
        }
      }
      break
    case 'EN':
      {
        const englishTextContent = {
          'about-link': 'About',
          'contact-link': 'Contact me',
          'inspiration-link': 'My Inspiration',
          'presentation-text': 'I have experience with web development using React on the frontend and Golang with MySQL on the backend, I also have knowledge of Docker and AWS and React Native.',
          'projects-link': 'Projects',
          title: "Hello! I'm Julian Florez<br />Fullstack developer with<br />React - Golang",
          'projects-title': 'Here are my best projects',

          'project1-title': 'Job posting web app',
          'project1-description':
            `Fullstack application for publishing job postings built with Golang, HTML, CSS, JS, Docker and AWS. Users can sign up and sign in either as a 'professional' or a 'company', view job posts, filter them, apply, create and manage their jobposts.`,

          'project2-title': 'Renting property app',
          'project2-description':
            'Freelance application for a local agency where users can request a renting contract with their own information and information about one or more co-signers. Includes multi-step form, input validations, loading states, different routes for renting contracts, documents upload and more.',

          'project3-title': 'Weather Forecaster',
          'project3-description':
            'Weather forecast for the current day and the upcoming 7 days, I used the open weather API for getting the data dynamically. I also made a side menu for display the weather on all countries in the world.',

          'project4-title': 'Advice Generator',
          'project4-description': 'This project lets you generate a random piece of advice on demand, this is possible because of the Advice Slip JSON API. I implemented the loading state for when the advice is being generated.',

          'project-github1': 'Github Repo',
          'project-site1': 'Live site',
          'project-github2': 'Github Repo',
          'project-site2': 'Live site',
          'project-github3': 'Github Repo',
          'project-site3': 'Live site',
          'about-title': 'About',


          'about-description-text1':
            "I have a bachelor's degree in Aeronautical Engineering and I've been doing web development for a couple of years now, mainly focused on frontend, but I also have experience with backend development and database management as well as the use of Docker and AWS for app deployment.",
          'about-description-text2':
            'On a more personal note, I like to hang out with family and friends and workout from time to time, I also make portraits with graphite pencil very occasionally ✍️ <span class="about__arrow-icon">🔽</span>',
          'tech-stack-title': 'Tech Stack',
          'tech-stack-current':
            'These are the technologies than I use on a regular basis:',
          'tech-stack-future': "And here some that I'd like to learn:",
          'inspiration-title': 'My Inspiration',
          'inspiration-description':
            'Here, some of the people that inspire me to be a better dev & person:',
          'inspiration-jon-list':
            '<li>Content creator</li><li>Web technologies teacher</li>',
          'inspiration-estefany-list':
            '<li>CSS friend</li><li>Frontend Developer</li><li>Teacher at Platzi</li>',
          'inspiration-midu-list':
            '<li>Content creator</li><li>React master</li>',
          'inspiration-kevin-list':
            '<li>Content creator</li><li>CSS evangelist</li>',
          'inspiration-angelika-list':
            '<li>Senior full-stack developer</li><li>Elixir advocate</li><li>Elixir track maintainer at exercism.io</li>',
          'contact-title': 'Contact',
          'contact-text':
            `Currently I'm looking for a role as a fullstack developer <br>(<span class="contact__react">React - Golang</span>), if you feel that I may be a good fit, don't hesitate in reaching out.`,
          'contact-cv-link': 'Download CV',
        }
        document
          .querySelectorAll('div[data-toggle-language]')
          .forEach(element => {
            element.textContent = 'ES'
          })

        for (const item of $elementsToChange) {
          const key = item.dataset.language
          // if()
          // item.textContent = spanishTextContent[key]
          item.innerHTML = englishTextContent[key]
          // item.innerHTML = $elementsToChange
        }
      }
      break
  }
}
